/**
 * DASHBOARD ROUTES
 */
const routes = [
  {
    path: '/',
    name: 'HomeViewComponent',
    component: 'Dashboard/HomeViewComponent'
  }
];

export default routes;
